import { Component, ViewChild } from '@angular/core';
import {
  GeneralLedgerDownloadTypes,
  GeneralLedgerExportTypes,
  GLConfiguration
} from '../../../../models/general-ledger';
import { ExportFilesPrimaryComponent } from './export-files-primary/export-files-primary.component';
import { Store } from '@ngxs/store';
import { GlLoadQboAccounts } from '../../../../state/GeneralLedgerState/GeneralLedger.state';
import { ModalService } from '../../../../services/modal.service';
import { ModalStates } from '../../../../models/modal';

@Component({
  selector: 'lib-gl-export-files-tab',
  templateUrl: './gl-export-files-tab.component.html',
  styleUrls: ['./gl-export-files-tab.component.css'],
  standalone: false
})
export class GlExportFilesTabComponent {
  //Only here to support some unit tests.
  @ViewChild('exportFilesTab')
  exportFilesTab: ExportFilesPrimaryComponent;

  public showMappings: boolean = false;
  public showCheckMappings: boolean = false;
  public chosenConfig: GLConfiguration;
  constructor(
    private store: Store,
    private modalService: ModalService
  ) {}

  public toggleMappings(chosenConfig: GLConfiguration) {
    if (chosenConfig == null) {
      //we're canceling the mapping.
      this.showMappings = false;
      this.showCheckMappings = false;
    } else {
      if (chosenConfig.ExportFileType === GeneralLedgerExportTypes.QBO) {
        this.store.dispatch(new GlLoadQboAccounts(chosenConfig.Id)).subscribe(
          _ => {
            this.switchScreens(chosenConfig);
          },
          err => {
            this.modalService.showAlertModal(
              `There was a problem connecting to Quickbooks Online. Please reconnect "${chosenConfig.Name}" to Quickbooks Online from the Settings tab.`,
              ModalStates.Error,
              null,
              'Error connecting to Quickbooks Online.'
            );
          }
        );
      } else {
        this.switchScreens(chosenConfig);
      }
    }
  }

  private switchScreens(chosenConfig: GLConfiguration) {
    if (chosenConfig.Type == GeneralLedgerDownloadTypes.Totals) {
      this.showMappings = !this.showMappings;
      this.showCheckMappings = false;
    } else {
      this.showMappings = false;
      this.showCheckMappings = !this.showCheckMappings;
    }
    this.chosenConfig = chosenConfig;
  }
}
